// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2RS5A","inputWrap":"styles_inputWrap__1A763","input":"styles_input__15Ul-"};